import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { ADMIN_PATHS, ADMIN_SEGMENT_LABELS } from '../../../routing/adminPaths.ts';

export const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const params = useParams<{ id?: string }>();
  const pathnames = location.pathname.split('/').filter(Boolean);

  const getSegmentLabel = (segment: string, index: number): string => {
    const lower = segment.toLowerCase();
    if (ADMIN_SEGMENT_LABELS[lower]) return ADMIN_SEGMENT_LABELS[lower];
    if (index > 0 && pathnames[index - 1] === 'organizations' && /^[a-zA-Z0-9-]+$/.test(segment)) {
      return params.id ? 'Details' : segment;
    }
    if (index > 0 && pathnames[index - 1] === 'users' && /^[a-zA-Z0-9-]+$/.test(segment)) {
      return params.id ? 'Details' : segment;
    }
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mt-1">
      <Link to={ADMIN_PATHS.DASHBOARD} className="hover:text-blue-600">
        Admin
      </Link>
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const displayName = getSegmentLabel(name, index);

        return (
          <React.Fragment key={routeTo}>
            <ChevronRight className="h-4 w-4 text-gray-400" />
            {isLast ? (
              <span className="text-gray-900 font-medium">{displayName}</span>
            ) : (
              <Link to={routeTo} className="hover:text-blue-600">
                {displayName}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
